import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  access_token: string | null;
}

const initialState: AuthState = {
  access_token: localStorage.getItem("__Iplot_admin_access_") || null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<AuthState>) => {
      const { access_token } = action.payload;
      state.access_token = access_token;

      if (access_token) {
        localStorage.setItem("__Iplot_admin_access_", access_token);
      }
    },
    clearCredentials: (state) => {
      state.access_token = null;

      localStorage.removeItem("__Iplot_admin_access_");
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
